import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// import { initIndexedDB } from './services/initIndexedDB';


// initIndexedDB();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker (for offline support)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/aac/service-worker.js') // ✅ Make sure this file exists in /public/aac
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
}
